import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";

const initialState = {
  mySettingVisible: false, // 我的设置 modal 显示
  accountSettingVisible: false, // 账号设置 modal 显示
  accountSettingRefreshTrigger: "", // 账号设置 modal 刷新 dependence
  phoneSettingVisible: false, // 修改手机号 modal 展示
  personalEmailSettingVisible: false, // 修改个人邮箱 modal 展示
  passwordSettingVisible: false, // 修改密码 modal 展示
};

export const settingSlice = createSlice({
  name: "setting",
  initialState: initialState,
  reducers: {
    setMySettingVisible: (state, action: PayloadAction<boolean>) => {
      state.mySettingVisible = action.payload;
    },
    setAccountSettingVisible: (state, action: PayloadAction<boolean>) => {
      state.accountSettingVisible = action.payload;
    },
    setAccountSettingRefreshTrigger: (state) => {
      const trigger = Math.random().toFixed(8).slice(2) + new Date().getTime();
      state.accountSettingRefreshTrigger = trigger;
    },
    setPhoneSettingVisible: (state, action: PayloadAction<boolean>) => {
      state.phoneSettingVisible = action.payload;
    },
    setPersonalEmailSettingVisible: (state, action: PayloadAction<boolean>) => {
      state.personalEmailSettingVisible = action.payload;
    },
    setPasswordSettingVisible: (state, action: PayloadAction<boolean>) => {
      state.passwordSettingVisible = action.payload;
    },
  },
});

export const {
  setMySettingVisible,
  setAccountSettingVisible,
  setAccountSettingRefreshTrigger,
  setPhoneSettingVisible,
  setPersonalEmailSettingVisible,
  setPasswordSettingVisible,
} = settingSlice.actions;

export const mapMySettingVisible = (state: RootState) =>
  state.setting.mySettingVisible;
export const mapAccountSettingVisible = (state: RootState) =>
  state.setting.accountSettingVisible;
export const mapAccountSettingRefreshTrigger = (state: RootState) =>
  state.setting.accountSettingRefreshTrigger;
export const mapPhoneSettingVisible = (state: RootState) =>
  state.setting.phoneSettingVisible;
export const mapPersonalEmailSettingVisible = (state: RootState) =>
  state.setting.personalEmailSettingVisible;
export const mapPasswordSettingVisible = (state: RootState) =>
  state.setting.passwordSettingVisible;

export default settingSlice.reducer;
